const FilterId = {
  SEARCH: 'search',
  DUE: 'due',
  STATUS: 'status',
};

export default FilterId;
